import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "antd/dist/reset.css";
import { installDigitNormalizer, installStatNumeral } from "./utils/digitNormalizer";
import { installDevOverlayGuard } from "./utils/devOverlayGuard";
import ErrorBoundary from "./components/ErrorBoundary";
import { installToastStyle } from "./utils/toastStyle";

// تبدیلِ خودکارِ ارقامِ فارسی/عربی به انگلیسی در همهٔ ورودی‌ها (سراسری)
installDigitNormalizer();
// نمایشِ فارسیِ ارقام در کارت‌های آمار (Statistic) برای یکدستیِ بصری
installStatNumeral();
// جلوگیری از اورلیِ بزرگِ خطای dev-server (نمایشِ نوارِ کوچک به‌جای آن)
installDevOverlayGuard();
// پیام‌های موقتِ بالای صفحه: خطا ۷ ثانیه، هشدار ۵ (ظاهرِ درشت در gharchak-theme.css)
installToastStyle();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// ثبت Service Worker برای PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((reg) => console.log("SW registered:", reg.scope))
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
